import actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    floor_id: null,
    name: null,
    planURL: null,
    fileName: null,
    fileSize: null,
    isPlanInverted: false,
  },
  mutations,
  actions,
};
